import $ from 'jquery';
import { Loader } from '@googlemaps/js-api-loader';

const google = window.google = window.google ? window.google : {};
const scolicare_options = window.scolicare_options;
const icon = scolicare_options.map_marker;
const options = {
	apiKey: scolicare_options.maps_key,
	libraries: ['places'],
};
let map, popup, autocomplete;
let markers = [];

( new Loader( options ) ).load().then( () => {
	const mapOptions = {
		'scrollwheel': false,
		'mapTypeId': 'roadmap',
		'styles': scolicare_options.maps_style,
	};
	const autoOptions = {
		types: ['address'],
	}

	map   = new google.maps.Map( document.getElementById( 'scolicare_map' ), mapOptions );
	popup = new google.maps.InfoWindow();
	autocomplete = new google.maps.places.Autocomplete( document.getElementById( 'alternate-address'), autoOptions );

	initMarkers( $( '#scolicare_markers' ).children() );
	initAutocomplete();
} );


function initMarkers( list ) {
	const bounds = new google.maps.LatLngBounds();

	$.each( list, function( index ) {
		const position = addMarker( $( list[ index ] ) );

		bounds.extend( position );
	} );

	const center = markers.hasOwnProperty( 0 );

	if ( center ) {
		focusMarker( markers[0], 10 );
	} else {
		map.fitBounds( bounds );
	}
}


function addMarker( element ) {
	const marker = _addMarker( {
		lat: element.data( 'lat' ),
		lng: element.data( 'lng' ),
	}, element.data( 'html' ), element.data( 'id' ) );

	return marker.position;
}


function _addMarker( coords, html, id ) {
	let position = new google.maps.LatLng( coords.lat, coords.lng )
	let marker   = new google.maps.Marker( { map, position, icon } );

	marker.html = html;
	marker.id = id;

	marker.addListener( 'click', function() {
		updatePopup( marker );
	} );
	markers[ id ] = marker;

	$( document ).on( 'click', '#clinic-' + marker.id + ' .marker', function() {
		focusMarker( marker );
	} );

	return marker;
}


function updatePopup( marker ) {
	popup.setContent( marker.html );
	popup.setOptions( { maxWidth: 350 } );
	popup.open( map, marker );
}


function focusMarker( marker, number = 14 ) {
	google.maps.event.trigger( marker, 'click' );
	map.setCenter( marker.getPosition() );
	map.setZoom( number );
}


function getCurrentLocation() {
	console.log( 'here' );

	return new Promise( ( resolve, reject ) => {
		console.log( 'inside' );

		if ( navigator.geolocation ) {
			navigator.geolocation.getCurrentPosition( position => {
				resolve( {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				} );
			}, () => {
				reject( 'Browser Blocked Access' );
			} );
		} else {
			reject( 'Browser Not Supported' );
		}
	} );
}


function reloadLocation( coords, name = null ) {
	const url = new URL( window.location.origin + window.location.pathname );

	url.searchParams.append( 'latitude', coords.lat );
	url.searchParams.append( 'longitude', coords.lng );

	if ( name ) {
		url.searchParams.append( 'location', name );
	} else {
		name = 'Current Location';
	}

	if ( markers.hasOwnProperty( 0 ) ) {
		markers[0].setMap( null );
	}

	const center = _addMarker( coords, name, 0 );

	window.history.replaceState( null, null, url );
	focusMarker( center, 10 );
	FWP.refresh();
}


export function updateLocation( coords, name = null ) {
	if ( coords ) {
		reloadLocation( coords, name );
	} else {
		console.log( 'before' );
		getCurrentLocation().then( resolve => {
			reloadLocation( resolve );
		}, reject => {
			alert( `Unable to get current location: *${reject}*` );
		} );
		console.log( 'after' );
	}
}


function initAutocomplete() {
	autocomplete.setFields( ['geometry', 'name'] );
	autocomplete.addListener( 'place_changed', setLocation );
}


function setLocation() {
	const place = autocomplete.getPlace();
	const location = place.geometry.location;

	updateLocation( {
		lat: location.lat(),
		lng: location.lng(),
	}, place.name );
}
